const key = 'MODEL_INVERTERS__';

exports.SET_CREATE_EDIT_MODEL_INVERTER = `${key}SET_CREATE_EDIT_MODEL_INVERTER`;
exports.SET_MODEL_INVERTER_ID_TO_EDIT = `${key}SET_MODEL_INVERTER_ID_TO_EDIT`;
